module.exports = __webpack_public_path__ + "img/pin-esmeralda.834564b0.png";